<template>
  <div class="page-container">
    <!-- 头部横幅 -->
    <section class="hero">
        <div class="container">
            <h1>{{ title }}</h1>
            <p>{{ subtitle }}</p>
        </div>
    </section>

    <div class="module-container">
      <!-- Tab 切换区域 -->
      <div class="tab-container-road">
          <!-- Tab 导航 -->
        <div class="tab-nav-road">
          <div 
              class="tab-item-road" 
              :class="{ active: activeTab === 'equity' }"
              @click="switchTab('equity')"
          >
            {{ equityObject.title }}
          </div>
          <div 
              class="tab-item-road" 
              :class="{ active: activeTab === 'debt' }"
              @click="switchTab('debt')"
          >
            {{ debtObject.title }}
          </div>
        </div>
  
        <!--  Tab 内容区域 -->
        <div class="tab-content">
          <!-- 股权投融资 Tab 内容 -->
          <div v-if="activeTab === 'equity'" class="tab-panel">
              <div class="panel-intro">
                <p>{{ equityObject.desc }}</p>
              </div>
              <div class="card-list">
                <!-- 循环生成卡片，通过index判断奇偶项，动态绑定布局类名 -->
                <div 
                  class="card-item" 
                  v-for="(item, index) in equityList" 
                  :key="item.title"
                  :class="{ 'card-item-reverse': index % 2 === 1 }"
                >
                  <!-- 左侧/右侧：图片区域 -->
                  <div class="card-img-wrapper">
                    <img :src="item.pic" alt="card-img" class="card-image" />
                  </div>

                  <!-- 右侧/左侧：内容区域 -->
                  <div class="card-content-wrapper">
                    <!-- 中间：居中标题 -->
                    <div class="card-title">{{ item.title }}</div>
                    <!--  行业标签 -->
                    <div class="card-title-industry">{{ item.industry }}</div>
                    <div class="card-title-industry">
                      {{ item.amount }}
                    </div>
                    <!-- 下方：左对齐详情（首行缩进2字符） -->
                    <div class="card-desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
          </div>
  
          <!-- 债权路演 Tab 内容 -->
          <div v-if="activeTab === 'debt'" class="tab-panel">
              <div class="panel-intro">
                <p>{{ debtObject.desc }}</p>
              </div>
              <div class="card-list">
                <!-- 循环生成卡片，通过index判断奇偶项，动态绑定布局类名 -->
                <div 
                  class="card-item" 
                  v-for="(item, index) in debtList" 
                  :key="item.title"
                  :class="{ 'card-item-reverse': index % 2 === 1 }"
                >
                  <!-- 左侧/右侧：图片区域 -->
                  <div class="card-img-wrapper">
                    <img :src="item.pic" alt="card-img" class="card-image" />
                  </div>

                  <!-- 右侧/左侧：内容区域 -->
                  <div class="card-content-wrapper">
                    <!-- 中间：居中标题 -->
                    <div class="card-title">{{ item.title }}</div>
                    <!--  行业标签 -->
                    <div class="card-title-industry">{{ item.industry }}</div>
                    <div class="card-title-industry">
                      {{ item.amount }}
                    </div>
                    <!-- 下方：左对齐详情（首行缩进2字符） -->
                    <div class="card-desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
          </div>
          </div>
      </div>
    </div>
    <!-- 返回按钮 -->
    <Back></Back>
  </div>
</template>

<script>
  import Back from '../components/Back.vue';

  export default {
    name: "Roadshow",
    components: {
      Back
    },
    data() {
      return {
        // 页面标题
        title: "International Sci-Tech Innovation Roadshow",
        // 页面副标题
        subtitle: "110+ roadshows, 600+ projects, precisely connecting sci-tech innovation projects with the capital market.",
        // 激活的 Tab 页
        activeTab: 'equity',
        // 股权投融资路演列表数据
        equityObject: {
          title: 'Equity Roadshow',
          desc: `The Enterprise Equity Investment and Financing Roadshow Platform is mainly targeted at startups and small-to-medium-sized tech enterprises that seek R&D and production funds by issuing equity during their development stage; the roadshow projects focus on industries such as intelligent manufacturing, intelligent robots, biomedicine and medical devices, and also cover sectors of high interest to investment institutions including new energy, advanced materials and internet platforms; meanwhile, the platform provides diversified financing channels for enterprises to meet the capital needs of businesses across different industries and development stages; each event mainly consists of policy sharing sessions, project roadshows, as well as comments and insights shared by professional institutions and foreign official agencies; in addition, we have joined hands with the Shenzhen Stock Exchange’s Capital Link V-Next Platform to conduct live online broadcasts of the events, expanding the publicity scope of the events and projects, attracting attention from more investors, securing capital support more effectively, and driving the further development of the projects.`
        },
        equityList: [
          {
            title: 'Intelligent Humanoid Robot',
            desc: `The company mainly engages in the R&D of high-end intelligent humanoid robots, as well as hardware and control systems with independent intellectual property rights. At present, it has launched a variety of intelligent robot products and derivatives, vigorously promoted the application of robots in diverse scenarios such as industrial intelligent manufacturing, commercial services, scientific research and education, and household services, and meanwhile established cooperation with many universities, research institutes and enterprises to jointly explore the development of humanoid robots in the fields of open-source frameworks, scenario algorithms and applications.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_kj.jpeg',
            industry: 'Intelligent Robot',
            amount: 'Financing Amount ：CNY 60,000,000'
          },
          {
            title: 'Optical Motion Capture System',
            desc: `The company specializes in optical spatial positioning and motion capture, large-space VR/AR/MR/holographic 3D interaction, immersive interaction, and digital twin application solutions. It has independently developed an optical motion capture system (abbreviated as RTS) with proprietary intellectual property rights, which has obtained a number of international invention patents. Based on self-developed infrared optical camera hardware and motion capture algorithms, focusing on multi-person intelligent interaction in complex environments and taking immersive scenario experience as the main line, the company strives to provide immersive interactive application solutions for fields such as education and training, military training, film and television shooting, medical care, emergency rescue, cultural tourism experience, and creative display, as well as high-end motion perception and interactive application solutions for fields including game animation production, sports posture analysis, industrial/medical/architectural simulation, and immersive digital twins.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_yy.jpeg',
            industry: 'Software and Information Technology',
            amount: 'Financing Amount ：CNY 60,000,000'
          },
          {
            title: 'Semiconductor Power Device Driver Chip',
            desc: `It is a high-tech enterprise specializing in power devices, modules and power ICs. The power devices mainly include silicon carbide diodes, silicon carbide MOSFETs, super-junction MOSFETs and IGBTs, while the power chips are mainly divided into two categories: power device driver chips and brushless motor driver chips. The ICs adopt advanced high-voltage characteristic processes, including the driving of power tubes and modules, as well as the driving of BLDC and FOC motors. For power device driver chips, the medium and low-voltage series have been mass-produced on a large scale, and the high-voltage series will be launched soon. In terms of motor driver chips, the single-phase BLDC cooling fan motor series and the three-phase BLDC motor driver series have been launched.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_xp.jpg',
            industry: 'Electronic Components',
            amount: 'Financing Amount ：CNY 80,000,000'
          },
          {
            title: 'UAV with Flight Control and Image Transmission System',
            desc: `It is a leading domestic enterprise in the field of industrial-grade unmanned aerial vehicles (UAVs) and wireless mobile video transmission systems, dedicated to the R&D, production and application of wireless mobile video transmission systems, multi-rotor UAV systems and wireless network transmission products. The company has a specialized UAV training center, and its products are widely used in fields such as military and police, emergency response, environmental protection, electric power, forestry, marine affairs, urban management, petrochemical industry and land surveying and mapping.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_wrj.jpg',
            industry: 'Intelligent UAV',
            amount: 'Financing Amount ：CNY 35,000,000'
          },
          {
            title: 'Flash Memory Controller Chip',
            desc: `It is mainly committed to the R&D of various flash memory controller chips and the provision of application solutions for flash memory products. It can customize flash memory and controllers for mass production and development according to user needs, and has the technology for independent design and development of SPI controller chips and operating software. At present, the company's main products are industrial-grade SLC NAND, SD NAND and P-NOR flash memory chips, which are widely used in communication equipment, set-top boxes, wearable devices and other fields. The company has a large number of customers including FiberHome, ZTE, China Mobile, China Unicom and Hikvision.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_xp.jpg',
            industry: 'Electronic Components',
            amount: 'Financing Amount ：CNY 30,000,000'
          },
          {
            title: 'All-Silicon MEMS Oscillator',
            desc: `It is committed to the independent R&D of MEMS oscillators, MEMS clock chips, MEMS sensor chips and other products. The team has years of experience in the development and mass production engineering of oscillators, clock chips and sensor chips, and the designed chips are widely used in telecommunications equipment, PC/server and smart terminal markets. All-silicon MEMS oscillators have the advantages of miniaturization, low power consumption, low electromagnetic radiation, shock resistance and vibration resistance. They play an important role in systems such as 5G communications, satellite navigation, national defense and military affairs, aerospace, artificial intelligence, automotive and autonomous driving systems, and the Internet of Things.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_kj.jpeg',
            industry: 'Electronic Components',
            amount: 'Financing Amount ：CNY 80,000,000'
          }
        ],
        // 债权路演列表数据
        debtObject: {
          title: 'Debt Financing Roadshow Platform',
          desc: 'The debt roadshow section has built a debt roadshow platform for enterprise technology upgrading and renovation, alleviating the capital needs of enterprises during the process of technology transformation and upgrading; after enterprises apply for relevant technology transformation support policies, it provides grants for the verified total investment and construction costs of their projects, as well as interest subsidies for loans and leases related to technology transformation projects; the activities adopt various forms including roadshow project conferences, financing matchmaking sessions and online platform exhibitions; each event invites more than ten enterprises that meet the conditions for policy subsidies, covering major technology transformation projects, equipment update-oriented technology transformation projects, intelligent transformation projects, industrial internet integration and innovation application projects, and digital transformation projects of traditional advantageous industries; meanwhile, it invites more than 30 different financial institutions to conduct face-to-face matchmaking with enterprises, realizing direct docking between enterprises and financial institutions such as banks, factoring companies, funds and financial leasing firms; in addition, the Bureau of Industry and Information Technology continues to expand the coverage of interest subsidies for technology transformation loans and relax restrictions on loan products of banking institutions, effectively alleviating the problems of "difficult and expensive financing" faced by enterprises.'
        },
        debtList: [
          {
            title: 'Peptide Drug R&D',
            desc: `It is a national high-tech enterprise specializing in the integrated R&D, production and sales of peptide drugs, which has always focused on the fields of peptide drugs and oligonucleotides. Adopting the dual-drive model of "independent R&D + internal and external resource integration", it has built a market-competitive product pipeline of "innovative drugs + generic drugs" and piloted emerging industries such as cosmetic peptides. At present, it is gradually expanding cooperation with high-quality and advanced technology companies, scientific research institutions, pharmaceutical enterprises and other entities with complementary resources at home and abroad.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_yiy.jpg',
            industry: 'Pharmaceutical Manufacturing Industry',
            amount: 'Financing Amount ：CNY 946,150,000'
          },
          {
            title: 'Intelligent Control System Solutions',
            desc: `The company's main business is the R&D, production and sales of intelligent control system solutions. With the "Four-Electricity and One-Network" technology matrix of electronic control, motors, batteries, power supplies and the Internet of Things platform as the core, it has built a complete technical ecological closed loop covering hardware development to cloud services. The company deeply serves three major fields including tools and home appliances, digital energy and intelligent vehicles, and robots, providing customized solutions for global customers.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_xt.webp',
            industry: 'Electrical Machinery and Equipment Manufacturing Industry',
            amount: 'Financing Amount ：CNY 300,000,000'
          },
          {
            title: 'RF Module Components',
            desc: `The company's main business is the R&D, production and sales of new chip passive electronic components such as chip power inductors, filters and chip LTCC RF components, as well as LCD display module devices, and it also provides technical support services and overall component solutions for downstream customers. The company's leading products are high-end passive electronic components with high precision in design and manufacturing. These products are widely used in fields such as communications, consumer electronics, computers, internet application products, LED lighting, automotive electronics and industrial equipment.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_xp.jpg',
            industry: 'Electrical Machinery and Equipment Manufacturing Industry',
            amount: 'Financing Amount ：CNY 170,000,000'
          },
          {
            title: 'New Energy Vehicle Manufacturing',
            desc: `The group is a unicorn enterprise integrating the R&D, production, sales and service of new energy vehicles, with four technical routes including pure electric, fuel cell, hybrid and plug-in types, and its product range covers a full series of new energy vehicle models such as passenger cars, buses, logistics vehicles, special-purpose vehicles, trucks and forklifts. Its vehicles are sold far and wide at home and abroad, covering more than 60 countries and over 200 cities.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_qc.jpg',
            industry: 'Automotive Manufacturing Industry',
            amount: 'Financing Amount ：CNY 130,000,000'
          },
          {
            title: 'High-Precision Double-Sided Multilayer Printed Circuit Board',
            desc: `The company is a high-tech enterprise specializing in the production of high-precision double-sided and multilayer printed circuit boards. It has advanced full-process production equipment for circuit boards, all equipped with complete testing and analysis equipment. Its customers include domestic and foreign high-tech enterprises such as SCI TECH, Mindray, Omron, Great Wall Motor, Hella, Geely, Xiaomi, ZTE New Energy, Ginlong Technologies, Deye New Energy, DENSO, GBM and AOC.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_xp.jpg',
            industry: 'Manufacturing of Computers, Communications and Other Electronic Equipment',
            amount: 'Financing Amount ：CNY 50,000,000'
          },
          {
            title: 'Minimally Invasive Interventional and In Vitro Diagnostic Products',
            desc: `The company's business covers life support, minimally invasive intervention, in vitro diagnostics and other fields. In recent years, it has fully acquired a world-renowned manufacturer of anesthesia and respiratory equipment, deeply integrated domestic and foreign professional technologies with the company's global R&D, manufacturing, marketing and operation support systems and experience, and jointly promoted technological innovation and the layout of the company's global operation.`,
            pic: 'https://res.roadlinkglb.com/pic/glb/glb_yiy.jpg',
            industry: 'Pharmaceutical Manufacturing Industry',
            amount: 'Financing Amount ：CNY 20,000,000'
          }
        ]
      };
    },
    methods: {
      // 切换 Tab 页方法
      switchTab(tabType) {
        this.activeTab = tabType;
      }
    }
  };
</script>
  
<style scoped>
/* 标题区样式（匹配原站风格） */
.modules-header {
  background-color: #1a3b69;
  text-align: center;
  padding: 4rem 2rem 2rem;
}
.modules-header .header-line {
  width: 60px;
  height: 3px;
  background-color: #ff9f43; /* 橙色点缀 */
  margin: 0 auto 1rem;
}
.modules-header h2 {
  font-size: 2rem;
  color: #ffffff; /* 深蓝主色 */
  margin: 0;
}
.modules-header p {
  color: #eceef0;
  font-size: 1.1rem;
  margin-top: 0.8rem;
}
  
/* 头部样式 */
.page-header {
background-color: #2444cb;
text-align: center;
padding: 30px 0;
border-bottom: 1px solid #eee;
margin-bottom: 30px;
}

.page-title {
font-size: 28px;
color: #ffffff;
margin-bottom: 15px;
}

.page-desc {
font-size: 16px;
color: #ffffff;
line-height: 1.6;
max-width: 800px;
margin: 0 auto;
}

/* Tab 导航样式 */
.tab-nav-road {
display: flex;
border-bottom: 2px solid #eee;
margin-bottom: 20px;
}

.tab-item-road {
padding: 12px 30px;
font-size: 18px;
color: #666;
cursor: pointer;
transition: all 0.3s ease;
border-bottom: 2px solid transparent;
}

.tab-item-road.active {
color: #1890ff;
border-bottom: 2px solid #1890ff;
font-weight: bold;
}

.tab-item-road:hover {
color: #1890ff;
}

.tab-panel p {
text-indent: 2em;
}

.panel-intro {
margin-bottom: 10px;
padding: 20px;
background-color: #f8f9fa;
border-radius: 8px;
}

.panel-intro h3 {
font-size: 20px;
color: #333;
margin-bottom: 10px;
}

.panel-intro p {
font-size: 16px;
color: #666;
line-height: 1.6;
}

/* 蓝色模块层 */
.module-blue {
background-color: #2444cb;
color: #ffffff;
}

.module-container {
max-width: 1200px;
padding: 20px;
background-color: #ffffff;
}


/**************************  卡片列表样式（保留网格布局，微调卡片最小宽度） */
.card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(680px, 1fr)); /* 加宽卡片，适配左右布局 */
  gap: 25px;
  padding: 10px 0;
}

/* 卡片基础样式（改为flex布局，实现左右分栏） */
.card-item {
  display: flex;
  align-items: center; /* 垂直居中，提升视觉协调度 */
  gap: 20px; /* 图片与内容的间距 */
  padding: 25px;
  border: 1px solid #eee;
  border-radius: 8px;
  transition: box-shadow 0.3s ease;
  box-sizing: border-box;
}

/* 偶数项：反转左右布局（图右文左） */
.card-item-reverse {
  flex-direction: row-reverse;
}

/* 卡片hover效果 */
.card-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 图片区域样式 */
.card-img-wrapper {
  width: 40%; /* 固定图片宽度，保证布局统一 */
  /* height: 120px; */
  flex-shrink: 0; /* 防止图片被挤压变形 */
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例，裁剪多余部分 */
  border-radius: 8px; /* 图片圆角，提升质感 */
}

/* 内容区域样式（占据剩余宽度，相对定位用于行业标签布局） */
.card-content-wrapper {
  flex: 1; /* 占据卡片剩余所有宽度 */
  position: relative; /* 为行业标签绝对定位提供参考 */
  min-height: 120px; /* 与图片高度匹配，保证垂直对齐 */
  display: flex;
  flex-direction: column; /* 内容垂直排列 */
  justify-content: center; /* 垂直居中，与图片对齐 */
}


/* 中间：居中标题 */
.card-title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin: 0 0 15px 0; /* 与详情拉开间距，取消上下多余间距 */
  text-align: center; /* 标题居中 */
  /* 避开行业标签，防止重叠 */
  /* padding-right: 80px; */
}

.card-title-industry {
  font-size: 14px;
  color: #1890ff;
  font-weight: bold;
  margin: 0 0 10px 0; /* 与详情拉开间距，取消上下多余间距 */
  text-align: center; /* 标题居中 */
  /* 避开行业标签，防止重叠 */
  /* padding-right: 80px; */
}

/* 下方：左对齐详情（首行缩进2字符） */
.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8; /* 提高行高，提升可读性 */
  margin: 0 0 15px 0;
  text-align: left; /* 左对齐 */
  text-indent: 2em; /* 首行缩进2个字符（核心需求） */
}

/* 底部：元信息 */
.card-meta {
  font-size: 16px;
  color: #1890ff;
  text-align: center; /* 元信息左对齐，与详情保持一致 */
}

/* 适配移动端：小屏幕下取消左右分栏，改为上下布局 */
@media (max-width: 768px) {
  .card-list {
    grid-template-columns: 1fr; /* 移动端单列布局 */
  }

  .card-item, .card-item-reverse {
    flex-direction: column; /* 上下布局 */
    gap: 15px;
    padding: 20px;
  }

  .card-img-wrapper {
    width: 100%;
    height: 180px;
  }

  .card-title {
    padding-right: 0; /* 移动端取消标题右侧内边距 */
  }

  .card-industry {
    position: static; /* 移动端取消绝对定位，正常排列 */
    display: inline-block;
    margin-bottom: 10px;
  }
}
/*************************  卡片列表样式（保留原有，无需修改） */


  </style>